// extracted by mini-css-extract-plugin
export default {"slider_title":"slick-title_slider_title__WUgOZ"};